module.exports = __webpack_public_path__ + "assets/images/qr_code706fbd42.png";